module.exports = __webpack_public_path__ + "static/media/XII_Fastà_Noite_-_28_de_maio_de_2017.JPG.85bf9b08.jpg";